module.exports = __webpack_public_path__ + "img/pingzheng.6c8c8478.png";